import { useLang } from "../store";

export default function Marquee() {
  const { t } = useLang();
  const word = t("marquee");
  const items = Array.from({ length: 6 });
  return (
    <div className="overflow-hidden border-y border-white/10 bg-[#0a0b0e] py-4" data-testid="marquee">
      <div className="marquee-track">
        {items.map((_, i) => (
          <span key={i} className="font-display flex items-center whitespace-nowrap text-3xl tracking-wide text-slate-700">
            {word.split(/(?=[A-Z])/).map((w, j) => (
              <span key={j} className="mx-4 flex items-center gap-4">
                <span className={j % 2 ? "text-amber-600/70" : ""}>{w}</span>
                <span className="inline-block h-2 w-2 rounded-full bg-amber-600" />
              </span>
            ))}
          </span>
        ))}
      </div>
    </div>
  );
}
